<script lang="ts">
	import type { Snippet } from "svelte"
	import { type ProjectorCommandSender } from "../types"
	import { type ProjectorCommand } from "projector-commands"

	interface Props {
		title: string
		id?: string
		command: ProjectorCommand
		sendCommand: ProjectorCommandSender
		children: Snippet
	}

	let { title, command, sendCommand, id, children }: Props = $props()

	let interval: number

	function createMousedownListener() {
		return () => {
			const clearListener = () => {
				clearInterval(interval)
				document.removeEventListener("mouseup", clearListener)
			}

			clearListener()

			interval = setInterval(() => {
				sendCommand(command)
			}, 500)

			document.addEventListener("mouseup", clearListener)
		}
	}

	function createClickListener() {
		return () => {
			sendCommand(command)
		}
	}
</script>

<button
	{id}
	{title}
	class="icon"
	onclick={createClickListener()}
	onmousedown={createMousedownListener()}
>
	{@render children()}
</button>

<style>
	button {
		width: 3rem;
		height: 3rem;
		padding: 0.25rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: var(--text-small);
	}

	button :global(svg) {
		height: 100%;
		width: auto;
	}

	button:not(:has(:global(svg))) {
		border-radius: 0.25rem;
	}

	button:not(:has(:global(svg))):hover {
		background-color: var(--color-bg);
	}
</style>
